import * as yup from "yup";

export const trimmedString = yup.string().trim();
